module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBracelets@2x.000258d.webp";